<template>
  <div class="selection selection__wrapper" :class= "[(show ) ? ' selection__wrapper--active' : '' ]">
    <StepDescription :title="title" :order="order" :endpoint="endpoint" :hasChosenProducts="hasChosenProducts" @clicked="onClick"/>
    <slide-up-down class="selection selection__inner" v-model="show" :duration="100">
      <p class="selection selection__description" >{{store.methods.getText(endpoint, "description")}}</p>
      <ProductGrid :endpoint="endpoint" :imageLayout="imageLayout" @updateChosenProductCheckmark="checkmarkUpdate" :extraText="extraText" v-if="checkComponentType('products')" />
      <Linje :endpoint="endpoint" :productEndpoint="productEndpoint" @updateChosenProductCheckmark="checkmarkUpdate" :extraText="extraText" :imageLayout="imageLayout" :productImageLayout="productImageLayout" @clicked="onClick" v-if="checkComponentType('linjer')" />
      <Size :endpoint="endpoint" :imageLayout="imageLayout" @updateChosenProductCheckmark="checkmarkUpdate" :extraText="extraText" v-if="checkComponentType('sizes')" />
      <Tillval :endpoint="endpoint" :imageLayout="imageLayout" @updateChosenProductCheckmark="checkmarkUpdate" :extraText="extraText" v-if="checkComponentType('tillval')" />
      <Choice :endpoint="endpoint" :imageLayout="imageLayout" @updateChosenProductCheckmark="checkmarkUpdate" :extraText="extraText" v-if="checkComponentType('choice')" />

    </slide-up-down>
  </div>
</template>

<script>

import { inject } from 'vue';
import StepDescription from './StepDescription.vue';
import ProductGrid from './ProductGrid.vue';
import Linje from './Linje.vue';
import Size from './Size.vue';
import SlideUpDown from 'vue3-slide-up-down';
import Tillval from './Tillval.vue';
import Choice from './Choice.vue';


export default {
  name: 'Selection',
  setup() {
    const store = inject('store');
    
    return {
      store
    }
  },
  data() {
    return {
      show: false,
      hasChosenProducts: false
    }
  },
  methods: {
    onClick(value) {
      this.show = value;
    },
    checkComponentType(currentComponentType) {
      if (this.componentType == currentComponentType) {
        return true;
      } else {
        return false;
      }
    },
    checkmarkUpdate(action) {
      if (action == "remove") {
        this.hasChosenProducts = false;
      }
      if (action == "add") {
        this.hasChosenProducts = true;
      }
    }
  },
  props: {
    order: Number,
    title: String,
    description: String,
    endpoint: String,
    componentType: String,
    productEndpoint: [String, Boolean],
    imageLayout: String,
    productImageLayout: [String, Boolean],
    extraText: String
  },
  components: {
    Tillval,
    StepDescription,
    ProductGrid,
    Linje,
    Size,
    SlideUpDown,
    Choice
  }
}
</script>
